import React, { createRef } from "react";

//spinner
import { BounceLoader } from "react-spinners";

//mui
import { Dialog } from "@mui/material";

//redux
import { useSelector } from "react-redux";

const Loader = () => {
  const ref = createRef();
  const open = useSelector((state) => state.loader.loader);

  return (
    <div>
      <Dialog
        open={open}
        disableEscapeKeyDown
        hideBackdrop
        PaperComponent="div"
        ref={ref}
        style={{
          background: "transparent",
          boxShadow: "none",
          // Never trap clicks: if a request forgets to clear the loader,
          // the invisible overlay used to freeze the whole admin until refresh.
          pointerEvents: "none",
        }}
      >
        <BounceLoader size={60} color="#222e3c" loading={open} />
      </Dialog>
    </div>
  );
};

export default Loader;
